// what's sent to add entitlement
export class ActivationProduct {
    username = "";
    authToken = "";
    crmAccountid = "";
    crmOrderid = "";
    crmInvoiceid = "";
    product = "";
    productVersion = "";
    productType = "";
    comment: string = null;
    endDate: string = null;
    days: number = null;
    numberToAdd: number = null;
    seats1: number = null;
    seats2: number = null;
    setfulfillstatus: boolean = null;
    productmapid: number = null;
}

// the productmaps table
export class Product {
    Id = "";
    ProductName = "";
    ProductVersion = "";
    ProductType = "";
    EmsProductVersion = "";
    IsIfw: boolean = null;
    CrmVendorProduct = "";
    IsDevKit: boolean = null;
    EmsId = "";
    EmsMap = "";
    IsNetwork: boolean = null;
    IsCid: boolean = null;
 }
